export default "__VITE_ASSET__OU_tH4C6__"